/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export interface AuthorizationState {
  authorized: boolean;
}

const initialState: AuthorizationState = {
  authorized: false,
};

export const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    authorize: (state) => {
      state.authorized = true;
    },
    authorizationError: (state) => {
      state.authorized = false;
    },
  },
});

export default authorizationSlice.reducer;

export const { authorize, authorizationError } = authorizationSlice.actions;
